import axios from "axios";

//const BASE_URl = 'http://localhost:4000/api/'
const BASE_URl = "https://xlra.beeinteractivemedia.com/api/";

export function submitForm(formKey, data) {
  return axios.post(`${BASE_URl}${formKey}`, data);
}

export function fetchKnowledgePosts() {
  return axios.get(`${BASE_URl}knowledgePostRoutes`);
}

export function fetchPageContent(slug) {
  return axios.get(`${BASE_URl}staticPage/key/${slug}`);
}

export function fetchNewsCategories() {
  return axios.get(`${BASE_URl}NewsCategory`);
}
export function fetchNewsPosts() {
  return axios.get(`${BASE_URl}NewsPost`);
}